import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api.js";

interface MeResponse {
  user: {
    id: string;
    email: string;
    name: string;
    role: string;
    accountType: string;
    companyId: string | null;
  } | null;
}

export function useAuth() {
  const { data, isLoading } = useQuery({
    queryKey: ["auth", "me"],
    queryFn: () => api<MeResponse>("/v1/auth/me"),
  });
  return { user: data?.user ?? null, loading: isLoading };
}
